import {
  getThemeWithMedia,
  LightTheme,
  Text,
  Link,
  colors,
} from "@a0/quantum-web";
import { ThemeProvider } from "styled-components";
import Image from "next/image";
import mediaSizes from "../shared/mediaSizes";
import Logo from "../shared/Logo";
import Icons from "./Icons";
import dictionary from "./dictionary";
import * as S from "./styled";

const Footer = () => (
  <ThemeProvider theme={getThemeWithMedia(LightTheme, mediaSizes)}>
    <S.MainWrapper>
      <S.TopWrapper>
        <S.LogoWrapper>
          <Logo />
        </S.LogoWrapper>
        <S.Navigation role="navigation" aria-label="footer-navigation">
          {dictionary.sections.map((section) => (
            <section key={section.title.text} role="navigation">
              {section.title.url ? (
                <S.TitleLink href={section.title.url} role="link">
                  <S.Overline>{section.title.text}</S.Overline>
                </S.TitleLink>
              ) : (
                <S.Overline as="p">{section.title.text}</S.Overline>
              )}
              <S.List role="menubar">
                {section.links.map((link) => (
                  <S.LinkWrapper key={link.text} role="menuitem">
                    <Link
                      size="xsmall"
                      href={link.url}
                      styleOverrides={{
                        color: colors.neutral_white,
                        "text-decoration": "none",
                      }}
                    >
                      {link.text}
                    </Link>
                    {link.label && <S.Label>{link.label}</S.Label>}
                  </S.LinkWrapper>
                ))}
              </S.List>
            </section>
          ))}
        </S.Navigation>
        <Icons />
      </S.TopWrapper>
      <S.BottomNavWrapper>
        <S.BottomContainer role="navigation" aria-label="legal-navigation">
          <Text
            type="Paragraph"
            size="xsmall"
            styleOverrides={{
              color: colors.neutral_n100,
              margin: 0,
            }}
          >
            {dictionary.bottom.rights}
          </Text>
          <S.Links role="menubar">
            {dictionary.bottom.links.map((link) => (
              <S.LinkWrapper key={link.text} role="menuitem">
                <Link
                  href={link.url}
                  size="xsmall"
                  styleOverrides={{
                    color: colors.neutral_n100,
                    "text-decoration": "none",
                    marginRight: link.icon
                      ? { default: "0.4rem", desktop: "0.8rem" }
                      : 0,
                  }}
                >
                  {link.text}
                </Link>
                {link.icon && (
                  <Image
                    src={link.icon}
                    alt="A button that resembles a pill is divided into two pieces: on the right side, there's an X mark; on the left side, there's a checkmark."
                    width={40}
                    height={18}
                    aria-hidden="true"
                  />
                )}
              </S.LinkWrapper>
            ))}
          </S.Links>
        </S.BottomContainer>
      </S.BottomNavWrapper>
    </S.MainWrapper>
  </ThemeProvider>
);

export default Footer;
